export function onlyNumbers(
  value: string,
  allowedChars = "",
  min?: number,
  max?: number
): string {
  const reg = new RegExp(`[^0-9${allowedChars}]`, "g");
  const cleaned = value.trim().replace(reg, "");
  if (cleaned === "") return "";

  const num = Number(cleaned);
  if (Number.isNaN(num)) return "";

  let clamped = num;
  if (typeof min === "number") clamped = Math.max(min, clamped);
  if (typeof max === "number") clamped = Math.min(max, clamped);

  return clamped.toString();
}
